<template>
    <div class="custom-progress-bar" :style="styleObject">
    </div>

</template>
<script>

    import {mapGetters} from "vuex";

    export default {
        props: {
            duration: Number
        },
        computed: {
          ...mapGetters('global', [
            'isMobile',
          ]),
            styleObject: function () {
                    return {
                        '--width': this.value/10+'%'
                    }
            }
        },
        created() {
            this.sessionProgress = setInterval(this.stepsCount, this.duration / 1000);
        },
        beforeDestroy() {
            clearInterval(this.sessionProgress);
        },

        methods: {
            stepsCount: function () {
                this.value++;

                    //clearInterval(this.sessionProgress);

                if (this.value >= 1000) {
                    this.$emit('timerOut');
                    clearInterval(this.sessionProgress);
                }
            },
        },
        data() {
            return {
                sessionProgress: 0,
                value: 0,
            }
        },
    }
</script>

<style scoped>
    .custom-progress-bar {
        width: var(--width);
        height: 0.3vw;
        border-radius: 0.3vw;
    }
    @media screen and (max-device-width: 767px) {
      .custom-progress-bar {
        height: 1.2vw;
        border-radius: 1.2vw;
      }
    }
</style>